<template>
  <main>
    <Trail />
    <HeroHome> </HeroHome>
    <!-- <AutoModal :show="showModal" @close="showModal = false"> </AutoModal> -->
  </main>
</template>

<script>
import programs from "@/data.js";
import HeroHome from "@/components/home/HeroHome";
import Trail from "@/components/common/Trail";
// import AutoModal from "./AutoModal.vue";
/*import ProjectList from "@/components/home/ProjectList"; */
/* import Publications from "@/components/home/Publications"; */

export default {
  components: {
    Trail,
    HeroHome,
    // AutoModal,
  },
  setup() {
    const program = programs[process.env.VUE_APP_PREFIX];
    return {
      program,
    };
  },
  data() {
    return {
      // showModal: true,
    };
  },
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.title {
  color: red;
}
.trail {
  border-top: 1px solid variables.$border-header-color;
  margin-bottom: 0;
}
.btn {
  margin-top: 2rem;
}
</style>
